"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosClientFactory = void 0;
const axios_1 = __importDefault(require("axios"));
const url_1 = require("url");
const generateTraceId_1 = require("./generateTraceId");
const addI18nNamespaceToErrorMessage_1 = require("./addI18nNamespaceToErrorMessage");
function axiosClientFactory(config, getTokens, getTraceId, removeTokens) {
    const instance = axios_1.default.create({
        baseURL: (0, url_1.format)(config.url),
        transformResponse: [
            ...axios_1.default.defaults.transformResponse,
            config.i18nNamespace ? (0, addI18nNamespaceToErrorMessage_1.addI18nNamespaceToErrorMessage)(config.i18nNamespace) : data => data
        ]
    });
    if (getTokens) {
        instance.interceptors.request.use(cfg => {
            return getTokens().then(token => {
                cfg.headers.common.Authorization = `Bearer ${token.accessToken}`;
                return cfg;
            });
        });
        if (removeTokens) {
            instance.interceptors.response.use(cfg => cfg, error => {
                var _a;
                if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    removeTokens();
                }
                return Promise.reject(error);
            });
        }
    }
    instance.interceptors.request.use(cfg => {
        if (getTraceId != null) {
            cfg.headers.common['X-B3-TraceId'] = getTraceId();
        }
        else {
            cfg.headers.common['X-B3-TraceId'] = (0, generateTraceId_1.generateTraceId)();
        }
        cfg.headers.common['X-B3-SpanId'] = (0, generateTraceId_1.generateTraceId)();
        return cfg;
    });
    instance.send = (url, data, metadata) => {
        let config;
        if (metadata) {
            config = {
                headers: {
                    common: {
                        'X-UT-GRPC-METADATA': JSON.stringify(metadata)
                    }
                }
            };
        }
        return instance.post(url, data, config);
    };
    return instance;
}
exports.axiosClientFactory = axiosClientFactory;
//# sourceMappingURL=axiosClientFactory.js.map